// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-content .bx--checkbox-label:before{width:16px;height:16px;font-size:14px;padding-left:8px}.panel-content .bx--checkbox-label:after{top:7px;left:7px;width:8px;height:3px}.panel-content .bx--form-item.bx--checkbox-wrapper:first-of-type{margin-top:8px}.panel-content .bx--checkbox-label-text{padding-left:10px;margin-top:3px;font-size:14px}", ""]);
// Exports
module.exports = exports;
